<template>
  <div>
    <vx-card>
      <ListProgramaAfiliados :subjectPermission="subjectPermission"></ListProgramaAfiliados>
    </vx-card>
  </div>
</template>

<script>
import ListProgramaAfiliados from "./../../lists/ListProgramaAfiliados";

export default {
  data() {
    return {
      subjectPermission: "Programa de Afiliados",
    };
  },
  methods: {},
  components: {
    ListProgramaAfiliados,
  },
};
</script>
